import React from "react";
import Image from "next/image";
import Moment from "react-moment";
import "moment-timezone";

import { chakra, Heading, Stack, Text, Box } from "@chakra-ui/react";

export const PostArticle = chakra("article");

export const ArticleBody = chakra("section", {
  baseStyle: {
    fontSize: { base: "sm", sm: "md" },
    "p, h1, h2, h3, h4, h5, h6": {
      mb: "3",
    },
    "ol, ul": {
      px: "4",
    },
    ".tribe-events-content blockquote": {
      quotes: "auto",
    },
    blockquote: {
      borderLeft: "5px solid",
      margin: "20px 0 30px",
      paddingLeft: "20px",
      fontSize: "md",
      fontWeight: "700",
    },
    ".powerpress_player audio": {
      mt: "8",
      mb: "4",
      boxShadow: "base",
      borderRadius: "90px",
    },
    ".et-box": {
      boxShadow: "0 1px 1px rgb(0 0 0 / 10%)",
      fontSize: "14px",
      position: "relative",
      paddingLeft: "unset",
      paddingRight: "unset",
      mb: "8",
    },
    ".et-shadow": {
      border: "1px solid #ddd",
    },
    ".et-box-content": {
      textShadow: "1px 1px 1px #fff",
      padding: "27px 43px 17px 66px",
      minHeight: "35px",
    },
    ".et-shadow .et-box-content": {
      color: "#737373",
      background: "#fafafa",
      border: "1px solid #fafafa",
      boxShadow: "inset 0 0 45px #e7e7e7",
    },
    ".et-info": {
      border: "1px solid #e2e2ba",
    },
    ".et-info .et-box-content": {
      color: "#ada771",
      background: "#f9f9dc",
      border: "1px solid #fbfbef",
      boxShadow: "inset 0 0 45px #efefc0",
    },
    ".et-warning:before, .et-download:before, .et-info:before, .et-bio:before, .et-shadow:before": {
      position: "absolute",
      top: "32px",
      left: "28px",
      content: '""',
    },
    ".et-box-content p": {
      my: "2",
    },
    ".et-info": {
      "&:before": {
        width: "22px",
        height: "20px",
        background: "url(/shortcodes-sprite.png) no-repeat -97px -2px",
      },
    },
    ".dealer-reel": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      listStyle: "none",
      width: "100%",
      li: {
        width: "50%",
        flexBasis: "50%",
        padding: "4",
      },
      "li a span img, li a span picture img": {
        objectFit: "contain",
        width: "100%",
        height: "auto",
        mx: "auto",
      },
    },
  },
});

export const PostTitle = chakra(Heading, {
  baseStyle: {
    fontSize: { base: "md", sm: "xl", md: "2xl" },
    textAlign: "center",
    pt: "10",
    pb: "4",
    fontWeight: "medium",
  },
});

export const PostMeta = ({ children }) => {
  return (
    <Stack
      direction="row"
      fontSize={{ base: "sm", md: "md" }}
      align="center"
      justify="center"
      pb="6"
      fontWeight="normal"
      color="gray.500"
      wrap="wrap"
      spacing={{ base: 1, md: 2 }}
    >
      {children}
    </Stack>
  );
};

export const EventMeta = ({ startDate, endDate, ...rest }) => {
  return (
    <Box {...rest}>
      <Text>
        <Moment date={startDate} format="MMMM DD" tz="America/Los_Angeles" /> @{" "}
        <Moment date={startDate} format="h:mm a" tz="America/Los_Angeles" /> -{" "}
        <Moment date={endDate} format="h:mm a" tz="America/Los_Angeles" />
      </Text>
    </Box>
  );
};

export const PostImageContainer = ({ children }) => {
  return (
    <Stack
      spacing="4"
      bg="gray.100"
      border="1px"
      borderColor="gray.300"
      px="6"
      pt="6"
      my="6"
      mx="auto"
      align="center"
      justify="center"
      width="fit-content"
      maxWidth="100%"
    >
      {children.map((child) => {
        if (child.type === "img") {
          return <Image key={child.props.alt} src={child.props.src} width={child.props.width} height={child.props.height} layout="intrinsic" />;
        } else {
          return child;
        }
      })}
    </Stack>
  );
};

export const FeatImage = chakra(Image, {
  baseStyle: {
    width: "100%",
    overflow: "hidden",
    object: "cover",
    maxHeight: "30rem",
  },
  shouldForwardProp: (prop) =>
    ["width", "height", "src", "alt", "layout"].includes(prop),
});

export const BodyImage = chakra(Image, {
  baseStyle: {
    overflow: "hidden",
    object: "fill",
    m: "0",
    p: "0",
  },
});
